import styles from './Sider.module.scss';
import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Menu from './Menu/Menu';
import Logo from './Logo/Logo';
import { useEffect } from 'react';
import { collapseSider, expandSider } from '../../../redux/actions/sider-menu';

const { Sider: SiderComponent } = Layout;

const Sider = () => {
    const dispatch = useDispatch();
    const collapsed = useSelector(state => state.siderMenu.isSiderCollapsed);

    useEffect(() => {
        const siderState = localStorage.getItem('sider');
        if (siderState === 'expanded') dispatch(expandSider());
        else dispatch(collapseSider());
    }, []);

    return (
        <SiderComponent collapsible trigger={null} collapsed={collapsed} className={styles.sider} collapsedWidth={60}>
            <div className={styles.siderHeader}>
                <Logo />
            </div>
            <Menu />
        </SiderComponent>
    );
};

export default Sider;
